<template>
  <div class="lotti-reset-password-container">

    <div class="lotti-grid-row lotti-grid-row-mid">

      <div class="lotti-grid-col lotti-grid-col-66">

        <div class="lotti-module">

          <div class="lotti-module-title">Passwort neu setzten</div>

          <el-form :model="resetForm" :rules="resetRules" label-width="80px" ref="resetForm" class="lotti-module-form">

            <el-alert
                class="lotti-reset-form-alert"
                title="ACHTUNG"
                type="warning"
                :closable="false"
                description="Bitte geben Sie Ihre E-Mail Adresse an, um Ihr Passwort neu setzen zu können. Folgen Sie den Instuktionen im E-Mail."
                show-icon>
            </el-alert>

            <el-form-item label="E-Mail" prop="email">
              <el-input placeholder="Bitte E-Mail eingeben" v-model="resetForm.email"></el-input>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" :loading="isLoading"  @click="submitData">Absenden</el-button>
              <el-button type="secondary" @click="$router.go(-1)">Zurück</el-button>
            </el-form-item>

          </el-form>

        </div>
      </div>

    </div>

  </div>
</template>


<script>
import Vue from '../../main.js';

//loading modules for dashboard-tiles
import routerHelper from "../../Helpers/RouterHelper";
import notification from "../../Helpers/NotificationHelper";
import validation from "../../Helpers/ValidationHelper";


export default {

  data() {

    return {
      isLoading: false,

      resetForm: {
        email: null,
      },

      resetRules: {
        email: [
          validation.getEmailValidationObject('change'),
          validation.getRequiredValidationObject('change')
        ],
      },
    }
  },

  methods: {

    submitData() {

      this.$refs['resetForm'].validate((valid) => {

        if (valid) {

          //set button in loading status
          this.isLoading = true;

          Vue.http.post(
              'api/v1/reset-password',
              {
                email: this.resetForm.email,
              }
          ).then(response => {

            //remove the query parameter by pushing to /
            routerHelper.routerPushToLogin(this)

            //show success msg
            notification.showSuccess(this, 'E-Mail zum neu setzten des Passworts wurde erfolgreich versendet.');

          }, error => {

            //remove the query parameter by pushing to /
            routerHelper.routerPushToLogin(this)

            notification.showError(this, 'Fehler beim absenden des E-mails');
          })
        }
      })
    },
  },
}

</script>